// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6883faad","732":"addbf4cf","977":"f501f316"}[chunkId] + ".chunk.js";
};